import { useQuery } from 'react-query'
import { getJSON } from 'common/services/api'
import { getQueryParams } from 'utils/getQueryParams'
import { StockRecord, ChartDataPoint, StockRecordsResponse } from '../types'
import dayjs from 'dayjs'
import { STOCK_LOGS_QUERY_KEY, STOCK_LOGS_URL } from './queryConstants'

type useStockRecordsProps = {
  medicationId: string
  startDate: dayjs.Dayjs
  endDate: dayjs.Dayjs
  includeChartData?: boolean
}

type useStockRecordsReturn = {
  records: StockRecord[]
  chartData: ChartDataPoint[]
  total: number
  isLoading: boolean
  refetch: () => void
  suggestedActivityDate?: string
}

export const useStockRecords = ({
  medicationId,
  startDate,
  endDate,
  includeChartData = true
}: useStockRecordsProps): useStockRecordsReturn => {
  const params = getQueryParams({
    residentMedicationId: medicationId,
    startDate: dayjs(startDate).format('YYYY-MM-DD'),
    endDate: dayjs(endDate).format('YYYY-MM-DD'),
    includeChartData: includeChartData.toString()
  })

  const { data, isLoading, refetch } = useQuery(
    [STOCK_LOGS_QUERY_KEY, params],
    () =>
      getJSON({
        url: `${STOCK_LOGS_URL}?${params}`
      }),
    {
      enabled: Boolean(medicationId && startDate && endDate),
      retry: 1
    }
  )

  return {
    records: data?.records || [],
    chartData: data?.chartData || [],
    total: data?.total || 0,
    isLoading,
    refetch,
    suggestedActivityDate: data?.suggestedActivityDate
  }
}

export default useStockRecords
